module.exports = __webpack_public_path__ + "static/media/lgaero.b9676db6.svg";